import React from 'react'
import Fade from 'react-reveal/Fade'
import SystemPolicyForm from '../../components/SystemPolicy/SystemPolicyForm/SystemPolicyForm'
import Table from '../../components/UI/Table/Table'
import FetchData from '../../shared/fetchData'

const SystemPolicies = (props) => {

    const [loading, setLoading] = React.useState(false)
    const [rerender, setRerender] = React.useState(false)
    const [pageSize, setPageSize] = React.useState(10)
    const [pageIndex, setPageIndex] = React.useState(0)
    const [pageCount, setPageCount] = React.useState(0)
    const [tableData, setTableData] = React.useState([])
    const [newPolicyPage, setNewPolicyPage] = React.useState(false)
    const [systemPolicy, setSystemPolicy] = React.useState([])
    React.useEffect(() => {
        setPageIndex(0)
        setPageSize(10)
        setPageCount(0)
    }, [])

    const getData = (pagination, isRefresh) => {
        setPageIndex(pagination.pageIndex)
        setPageSize(pagination.pageSize)
        setLoading(true);
        var raw = !!isRefresh && isRefresh ? JSON.stringify({
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        }) : JSON.stringify({
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/systempolicies/getSystemPolicies'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    let newList = []
                    for (let i = 0; i < (pagination.pageIndex * pagination.pageSize); i++) {
                        newList.push([]);
                    }
                    newList = newList.concat(result.systemPolicy)
                    pushData(newList)
                    setSystemPolicy(newList)
                    setPageCount(result.count)
                    setLoading(false);
                } else {
                    setLoading(false)
                }
            })
            .catch(error => setLoading(false))
    }
    const pushData = (data) => {
        const rows = [];
        const headers = [
            {
                accessorKey: 'maxKioskNumber',
                header: "بیشترین تعداد لاکر در هر جستجو",
                align: 'center',
            },
            {
                accessorKey: 'maxDistanceToKiosk',
                header: "بیشترین فاصله لاکر",
                align: 'center',
            },
            {
                accessorKey: 'maxIntervalReserveFromNow',
                header: "بیشترین فاصله زمانی تا رزرو",
                align: 'center',
            },
            {
                accessorKey: 'minDurationReserve',
                header: "کمترین زمان مجاز برای رزرو",
                align: 'center',
            },
            {
                accessorKey: 'maxDurationReserve',
                header: "بیشترین زمان مجاز برای رزرو",
                align: 'center',
            },
            {
                accessorKey: 'deadlineOfConfirmOrder',
                header: "بیشترین زمان مجاز برای تایید سفارش",
                align: 'center',
            },
            {
                accessorKey: 'cancelInterval',
                header: "حداقل فاصله زمانی برای کنسل کردن",
                align: 'center',
            },
        ];
        const buttons = [];
        buttons.push({ id: 1, text: 'ویرایش', clicked: editSystemPolicy });
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        data.map(d => {
            rows.push({
                id: d.id,
                maxKioskNumber: d.maxKioskNumber,
                maxDistanceToKiosk: d.maxDistanceToKiosk,
                maxIntervalReserveFromNow: d.maxIntervalReserveFromNow,
                minDurationReserve: d.minDurationReserve,
                maxDurationReserve: d.maxDurationReserve,
                deadlineOfConfirmOrder: d.deadlineOfConfirmOrder,
                cancelInterval: d.cancelInterval,
            });
        })
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        setRerender(!rerender);
    }
    const editSystemPolicy = (id) => {
        setNewPolicyPage(true)
    }
    const toggleNewPolicyForm = (event, value) => {
        if (!value) {
            getData({ pageIndex: pageIndex, pageSize: pageSize })
        }
        setNewPolicyPage(value)
    }
    return (
        <div>
            {!newPolicyPage ?
                <Fade duration={200} left cascade>
                    <div>
                        <div className="mt-5">
                            {rerender ?
                                // <Spinner />
                                <Table hasDetails={false} data={SystemPolicies} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={300} loading={loading} />
                                :
                                <Table hasDetails={false} data={SystemPolicies} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={300} loading={loading} />
                            }
                        </div>
                    </div>
                </Fade>
                :
                <SystemPolicyForm systemPolicy={systemPolicy[0]} toggleNewPolicyForm={toggleNewPolicyForm} />}
        </div>
    )
}
export default SystemPolicies